import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { ReserveProvider } from "@/contexts/ReserveContext";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import MenuPage from "@/pages/MenuPage";
import MapsPage from "@/pages/MapsPage";
import ContactPage from "@/pages/ContactPage";
import EventsPage from "@/pages/EventsPage";

function App() {
    return (
        <div className="App">
            <LanguageProvider>
                <BrowserRouter>
                    <ReserveProvider>
                        <Layout>
                            <Routes>
                                <Route path="/" element={<HomePage />} />
                                <Route path="/menu" element={<MenuPage />} />
                                <Route path="/events" element={<EventsPage />} />
                                <Route path="/location" element={<MapsPage />} />
                                <Route path="/contact" element={<ContactPage />} />
                            </Routes>
                        </Layout>
                        <Toaster position="top-center" richColors />
                    </ReserveProvider>
                </BrowserRouter>
            </LanguageProvider>
        </div>
    );
}

export default App;
